import { __rest, __assign } from '../../_virtual/_tslib.js';
import React__default from 'react';
import { LinearProgress } from './LinearProgress/LinearProgress.js';
import { CircleProgress } from './CircleProgress/CircleProgress.js';
import { AnimatedProgress } from './AnimatedProgress/AnimatedProgress.js';

var Progress = function (_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.shape, shape = _c === void 0 ? 'linear' : _c, _d = _a.cycled, cycled = _d === void 0 ? false : _d, _e = _a.strokeWidth, strokeWidth = _e === void 0 ? 4 : _e, _f = _a.size, size = _f === void 0 ? 44 : _f, _g = _a.type, type = _g === void 0 ? 'container' : _g, props = __rest(_a, ["value", "shape", "cycled", "strokeWidth", "size", "type"]);
    if (shape === 'linear') {
        return React__default.createElement(LinearProgress, __assign({ value: value, type: type, cycled: cycled, strokeWidth: strokeWidth }, props));
    }
    if (shape === 'animated') {
        return React__default.createElement(AnimatedProgress, __assign({}, props));
    }
    // В случае передачи 0 в круговой прогресс.
    if (!size) {
        return null;
    }
    return React__default.createElement(CircleProgress, __assign({ value: value, cycled: cycled, strokeWidth: strokeWidth, size: size }, props));
};

export { Progress };
